import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectActivity = nullBind(getAnyOrNull, 'activity');
export const selectActivityFeedData = nullBind(getAnyOrNull, 'activity.feedData');
export const selectActivityNextUrl = nullBind(getAnyOrNull, 'activity.nextUrl');
export const selectActivityNewItems = nullBind(getAnyOrNull, 'activity.newItems');

